<div class="absolute inset-0 flex min-w-0 flex-auto flex-col overflow-hidden">
  <mat-drawer-container class="bg-card h-full flex-auto" (backdropClick)="backdropClicked()">
    <mat-drawer
      #detailsDrawer
      class="w-screen min-w-screen bg-slate-100"
      [disableClose]="true"
      [mode]="'over'"
      [ngClass]="{ 'md:w-240 md:min-w-240': drawerType() === 'view', 'md:w-120 md:min-w-120': drawerType() === 'search' }"
      [opened]="false"
      [position]="'end'">
      @if (drawerType() === 'view') {
        <router-outlet></router-outlet>
      }
    </mat-drawer>

    <mat-drawer-content class="flex flex-col overflow-hidden">
      <div class="relative flex flex-0 flex-col justify-between p-6">
        <div class="flex w-full items-center justify-between">
          <subtitle-header [title]="'ship_interface.noon_report' | transloco" (toggle)="toggleSidebar()"></subtitle-header>
        </div>

        <div class="mt-4 flex w-full shrink-0 items-center justify-between">
          <shared-advance-filter-container
            [config]="advanceFilterConfig"
            [queryParams]="queryParams()"
            [queryListAdvanceFilter]="queryAdvanceFilter"
            (queryParamsChangedEvent)="queryParams.set($event)"
            (navigateWithParamsEvent)="navigateWithParams($event)" />

          <div class="flex shrink-0 items-center space-x-1 md:space-x-4">
            <button
              *permission="['noon_report_ship_interface', ['generate_excel']]"
              mat-flat-button
              class="dark-excel-button hidden md:flex md:flex-1"
              [color]="'accent'"
              (click)="exportToExcel()"
              [disabled]="downloadingExcel()">
              @if (downloadingExcel()) {
                <mat-spinner class="h-4 w-4 dark:text-slate-50"></mat-spinner>
              } @else {
                <div class="flex items-center">
                  <mat-icon class="icon-size-5" [svgIcon]="'sealicons_outline:excel'"></mat-icon>
                  <span class="ml-2 mr-1">{{ 'button.excel' | transloco }}</span>
                </div>
              }
            </button>

            <button class="bg-primary" mat-flat-button *permission="['noon_report_ship_interface', ['create']]" [color]="'primary'" (click)="createReport()">
              <mat-icon [svgIcon]="'heroicons_outline:plus'"></mat-icon>

              <span class="ml-2">{{ 'ship_interface.add' | transloco }}</span>
            </button>
          </div>
        </div>
      </div>

      <div class="flex flex-auto flex-col overflow-hidden px-6">
        <lync-table class="mb-[73px] w-full flex-auto overflow-y-auto" [config]="tableConfig" [rows]="vesselReports()" />

        <mat-paginator
          class="bg-card z-10 flex items-center justify-end border-b sm:absolute sm:inset-x-6 sm:bottom-0 sm:border-b-0 sm:border-t"
          [length]="stateService.pagination()?.total"
          [ngClass]="{ 'pointer-events-none': vesselReportsLoading }"
          [pageIndex]="stateService.pagination()?.current_page - 1"
          [pageSizeOptions]="[10, 25, 50, 100]"
          [pageSize]="stateService.pagination()?.per_page"
          [showFirstLastButtons]="true"></mat-paginator>
      </div>
    </mat-drawer-content>
  </mat-drawer-container>
</div>
